import { useEffect, useState } from "react";

const NEW_CATEGORY = "__new__";

function isKnownCategory(value, categories) {
    return !!value && categories.includes(value);
}

export default function CategoryField({ value, categories, onChange, required = true }) {
    const [showCustom, setShowCustom] = useState(() => !!value && !isKnownCategory(value, categories));

    useEffect(() => {
        if (isKnownCategory(value, categories)) {
            setShowCustom(false);
        } else if (value) {
            setShowCustom(true);
        }
    }, [value, categories]);

    const selectValue = showCustom ? NEW_CATEGORY : (value || "");

    return (
        <label className="field">
            Catégorie
            <select
                value={selectValue}
                onChange={(event) => {
                    const selected = event.target.value;
                    if (selected === NEW_CATEGORY) {
                        setShowCustom(true);
                        onChange("");
                        return;
                    }
                    setShowCustom(false);
                    onChange(selected);
                }}
                required={required && !showCustom}
            >
                <option value="" disabled={!!value || showCustom}>
                    Choisir une catégorie
                </option>
                {categories.map((category) => (
                    <option key={category} value={category}>{category}</option>
                ))}
                <option value={NEW_CATEGORY}>Nouvelle catégorie…</option>
            </select>
            {showCustom && (
                <input
                    className="category-field-custom"
                    value={value}
                    onChange={(event) => onChange(event.target.value)}
                    placeholder="Saisir une nouvelle catégorie"
                    required={required}
                />
            )}
        </label>
    );
}
